export type RouterMode = 'static' | 'dynamic'

const rawMode = (import.meta.env.VITE_ROUTER_MODE as string | undefined) || 'dynamic'

export const ROUTER_MODE: RouterMode = rawMode === 'static' ? 'static' : 'dynamic'

export const isStaticMode = (): boolean => ROUTER_MODE === 'static'

export const isDynamicMode = (): boolean => ROUTER_MODE === 'dynamic'
